/**
 * Datos de patrocinadores del CEC 2026
 * 
 * Para agregar un patrocinador:
 * 1. Colocá el logo en /public/assets/images/sponsors/
 * 2. Agregá una entrada en el nivel correspondiente
 * 
 * Niveles (de mayor a menor):
 *   - Agencies (Agencias Espaciales Participantes 🚀)
 *   - Constellation (Constelación ✨ - US$8,000)
 *   - Galaxy (Galaxia 🌌 - US$5,000)
 *   - SolarSystem (Sistema Solar ☀️ - US$2,500)
 *   - Star (Estrella ⭐ - US$1,000)
 *   - Planet (Planeta 🪐 - US$500)
 */

const sponsorsData = {
  agencies: {
    label: { es: "Agencias Espaciales Participantes", en: "Participating Space Agencies" },
    icon: "🚀",
    color: "#1a2e4a",
    sponsors: [
      {
        id: "agency-nasa",
        name: "NASA",
        img: "/assets/images/participants/NASA.png",
        href: "https://www.nasa.gov/",
        invertLogo: false,
      },
      {
        id: "agency-jaxa",
        name: "JAXA",
        img: "/assets/images/participants/JAXA.png",
        href: "https://www.jaxa.jp/",
        invertLogo: false,
      },
      {
        id: "agency-aeb",
        name: "AEB",
        img: "/assets/images/participants/AEB.png",
        href: "https://www.gov.br/aeb/",
        invertLogo: true,
      },
      {
        id: "agency-dlr",
        name: "DLR",
        img: "/assets/images/participants/DLR.png",
        href: "https://www.dlr.de/",
        invertLogo: false,
      },
      {
        id: "agency-isro",
        name: "ISRO",
        img: "/assets/images/participants/ISRO.png",
        href: "https://www.isro.gov.in/",
        invertLogo: false,
      },
    ],
  },
  constellation: {
    label: { es: "Constelación", en: "Constellation" },
    icon: "✨",
    color: "#764ba2",
    sponsors: [
      {
        id: "sponsor-constellation-starlab",
        name: "Starlab",
        img: "/assets/images/sponsors/starlab.png",
        href: "https://starlab-space.com/",
        invertLogo: false,
      },
      {
        id: "sponsor-constellation-iias",
        name: "International Institute for Astronautical Sciences",
        img: "/assets/images/sponsors/iias.png",
        href: "https://astronauticsinstitute.org/",
        invertLogo: false,
      },
    ],
  },
  galaxy: {
    label: { es: "Galaxia", en: "Galaxy" },
    icon: "🌌",
    color: "#667eea",
    sponsors: [
      {
        id: "sponsor-star-beyondsight",
        name: "BeyondSight",
        img: "/assets/images/sponsors/beyond_sight.png",
        href: "https://www.instagram.com/beyondsightt/",
        invertLogo: false,
      },
    ],
  },
  solarSystem: {
    label: { es: "Sistema Solar", en: "Solar System" },
    icon: "☀️",
    color: "#f7b733",
    sponsors: [
      {
        id: "sponsor-solar-telescopiosgt",
        name: "Telescopios de Guatemala",
        img: "/assets/images/sponsors/telescopios_de_guatemala.png",
        href: "https://www.instagram.com/telescopiosgt",
        invertLogo: false,
      },
      {
        id: "sponsor-star-arkysis",
        name: "Arkisys",
        img: "/assets/images/sponsors/arkisys.png",
        href: "https://www.arkisys.com/",
        invertLogo: true,
      },
      {
        id: "sponsor-star-astrion",
        name: "Astrion",
        img: "/assets/images/sponsors/astrion.png",
        href: "https://www.astrion.us/",
        invertLogo: false,
      },
    ],
  },
  star: {
    label: { es: "Estrella", en: "Star" },
    icon: "⭐",
    color: "#11998e",
    sponsors: [
      {
        id: "sponsor-kapital",
        name: "Kapital",
        img: "/assets/images/sponsors/kapital.png",
        href: "https://www.kapital.com.gt/",
        invertLogo: false,
      },
      {
        id: "sponsor-star-nassar",
        name: "Nassar Abogados",
        img: "/assets/images/sponsors/nassar.png",
        href: "https://www.nassarabogados.com/",
        invertLogo: true,
      },
      {
        id: "sponsor-star-universales",
        name: "Seguros Universales",
        img: "/assets/images/sponsors/seguros_universales.png",
        href: "https://www.universales.com/",
        invertLogo: false,
      },
      {
        id: "sponsor-solar-nara-space",
        name: "Nara Space",
        img: "/assets/images/sponsors/nara_space.png",
        href: "https://naraspace.com/",
        invertLogo: true,
      },
      {
        id: "sponsor-solar-uvg-alumni",
        name: "UVG Alumni",
        img: "/assets/images/sponsors/uvg_alumni.png",
        href: "https://uvg.edu.gt/impacto/uvgalumni",
        invertLogo: false,
      },
      {
        id: "sponsor-solar-ambev",
        name: "Cervecería Ambev",
        img: "/assets/images/sponsors/ambev.png",
        href: "https://cerveceriaambev.gt",
        invertLogo: false,
      },
    ],
  },
  planet: {
    label: { es: "Planeta", en: "Planet" },
    icon: "🪐",
    color: "#36d1dc",
    sponsors: [
      // Agregá acá, por ejemplo:
      {
        id: "salvavidas",
        name: "Agua Pura Salvavidas",
        img: "/assets/images/sponsors/salvavidas.png",
        href: "https://www.aguapurasalvavidas.com/",
        invertLogo: false,
      },
      {
        id: "Santa Delfina",
        name: "Agua Pura Salvavidas",
        img: "/assets/images/sponsors/santa_delfina.png",
        href: "https://www.instagram.com/santadelfinagt",
        invertLogo: true,
      },
      {
        id: "OAG",
        name: "Observatorio Astronómico Guaatemala",
        img: "/assets/images/sponsors/oag.png",
        href: "https://www.oaguatemala.org/",
        invertLogo: true,
      },
      {
        id: "European Space Foundation",
        name: "European Space Foundation",
        img: "/assets/images/sponsors/esf.png",
        href: "https://spacefdn.com/",
        invertLogo: false,
      },
    ],
  },
  institutions: {
    label: { es: "Instituciones Participantes", en: "Participating Institutions" },
    icon: "🏛️",
    color: "#555555",
    sponsors: [
      {
        id: "inst-crest",
        name: "CREST",
        img: "/assets/images/participants/CREST.png",
        href: "https://crest.ucsc.edu",
        invertLogo: true,
      },
      {
        id: "inst-cluster-cr",
        name: "Cluster Aeroespacial de Costa Rica",
        img: "/assets/images/participants/ClusterCR.png",
        href: "https://costaricaaerospace.com",
        invertLogo: true,
      },
      {
        id: "inst-earsc",
        name: "EARSC",
        img: "/assets/images/participants/EARSC.png",
        href: "https://earsc.org",
        invertLogo: false,
      },
      {
        id: "inst-karman",
        name: "Karman",
        img: "/assets/images/participants/Karman.png",
        href: "https://karmanproject.org",
        invertLogo: false,
      },
      {
        id: "inst-starlogics",
        name: "Starlogics",
        img: "/assets/images/participants/Starlogics.png",
        href: "https://starlogicscr.com/",
        invertLogo: true,
      },
      {
        id: "fiu",
        name: "FIU Jack D. Gordon Institute for Public Policy",
        img: "/assets/images/participants/FIU.png",
        href: "https://gordoninstitute.fiu.edu",
        invertLogo: false,
      },
      {
        id: "acc",
        name: "Asociación Costarricense de Cohetería",
        img: "/assets/images/participants/ACC.png",
        href: "https://coheteriacr.org/",
        invertLogo: false,
      },
    ],
  },
};

export default sponsorsData;